import script from "./theme-modal.vue?vue&type=script&lang=js"
export * from "./theme-modal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__